import { render, staticRenderFns } from "./AllowedEqpTypeDetailPanel.vue?vue&type=template&id=4bcaffa8&scoped=true"
import script from "./AllowedEqpTypeDetailPanel.vue?vue&type=script&lang=js"
export * from "./AllowedEqpTypeDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./AllowedEqpTypeDetailPanel.vue?vue&type=style&index=0&id=4bcaffa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcaffa8",
  null
  
)

export default component.exports